export const fetchData = (url, locale, nextParametr) => async () => {
  const response = await fetch(
    process.env.REACT_APP_API_URL +
      url +
      (locale ? "?_locale=" + locale : "") +
      (nextParametr ? `&${nextParametr}` : "")
  );
  return response.json();
};
